const SVG = ({ fill = 'none', width = '24', height = '24', viewBox = '0 0 24 24' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.063 6.053c.077-.464.358-.848.69-1.18L3.826 2.8c.64-.64 1.677-.64 2.316 0l2.703 2.703c.64.64.64 1.677 0 2.316L7.456 9.21c-.292.292-.391.724-.208 1.095.37.752 1.175 2.112 2.71 3.649 1.537 1.536 2.898 2.34 3.65 2.71.37.184.803.085 1.095-.207l1.39-1.39c.639-.64 1.676-.64 2.316 0l2.79 2.792c.64.64.64 1.677 0 2.316l-2.072 2.073c-.332.332-.716.613-1.18.69-1.459.242-5.244.066-11.097-5.787S.82 7.512 1.063 6.053z"
      stroke="#192043"
      strokeWidth="1.25"
    />
    <path
      d="M12.995 5.022s1.995.193 3.797 1.995 1.995 3.796 1.995 3.796M13.478 1s3.343.255 6.306 3.217c2.963 2.963 3.217 6.307 3.217 6.307"
      stroke="#4E546C"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
)

export default SVG
